import React from "react";

import { InfoModalResDto } from "@/models/infoModalRes.dto";

import { InfoModal } from "./Info.modal";

type PropTypes = InfoModalResDto & {
  onSignInClick: () => void;
  onRecoverClick: () => void;
};

export const RecoverSuggestModal: React.FC<PropTypes> = ({
  message,
  statusReg,
  onSignInClick,
  onRecoverClick,
}) => {
  return (
    <InfoModal statusReg={statusReg}>
      <InfoModal.Message>{message}</InfoModal.Message>
      <InfoModal.ButtonContainer>
        <InfoModal.Button onClick={onRecoverClick}>Recover</InfoModal.Button>
        <InfoModal.Button onClick={onSignInClick}>Login</InfoModal.Button>
      </InfoModal.ButtonContainer>
    </InfoModal>
  );
};
